/* ==========================================================================
   LUMINISH — JS propio (prefijo mt-). Vanilla, sin librerías externas.
   ========================================================================== */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal, .mt-reveal-scale");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll("[data-mt-galeria]").forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-galeria-principal]");
      var minis = galeria.querySelectorAll("[data-mt-galeria-mini]");
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-full");
          if (!src) return;
          principal.src = src;
          minis.forEach(function (m) { m.classList.remove("is-activa"); m.setAttribute("aria-pressed", "false"); });
          mini.classList.add("is-activa");
          mini.setAttribute("aria-pressed", "true");
        });
      });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    var fmt = format || "{{amount}} €";
    return fmt.replace(/\{\{\s*amount[a-zA-Z_]*\s*\}\}/, value);
  }

  function initVariantes() {
    document.querySelectorAll("[data-mt-producto-form]").forEach(function (root) {
      var dataEl = root.querySelector("[data-mt-variantes]");
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('input[name="id"]');
      var precioEl = document.querySelector("[data-mt-precio]");
      var precioBarraEl = document.querySelector("[data-mt-precio-barra]");
      var precioTachadoEl = document.querySelector("[data-mt-precio-tachado]");
      var estadoEl = root.querySelector("[data-mt-estado]");
      var boton = root.querySelector("[data-mt-add]");
      var botonBarra = document.querySelector("[data-mt-add-barra]");
      var pills = root.querySelectorAll("[data-mt-opcion-pill]");
      var galeriaPrincipal = document.querySelector("[data-mt-galeria-principal]");
      var moneyFormat = root.getAttribute("data-money-format") || "{{amount}} €";

      function opcionesSeleccionadas() {
        var sel = [];
        var grupos = {};
        pills.forEach(function (p) {
          if (p.classList.contains("is-activa")) grupos[p.getAttribute("data-opcion-index")] = p.getAttribute("data-valor");
        });
        var idx = 0;
        while (grupos[idx] !== undefined) { sel.push(grupos[idx]); idx++; }
        return sel;
      }

      function encontrarVariante() {
        var sel = opcionesSeleccionadas();
        return variants.find(function (v) {
          return v.options.length === sel.length && v.options.every(function (val, i) { return val === sel[i]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        idInput.value = variante.id;
        var precio = formatMoney(variante.price, moneyFormat);
        if (precioEl) precioEl.textContent = precio;
        if (precioBarraEl) precioBarraEl.textContent = precio;
        if (precioTachadoEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioTachadoEl.innerHTML = '<span class="visually-hidden">Precio anterior:</span> ' + formatMoney(variante.compare_at_price, moneyFormat);
            precioTachadoEl.style.display = "";
          } else {
            precioTachadoEl.style.display = "none";
          }
        }
        [boton, botonBarra].forEach(function (b) { if (b) b.disabled = !variante.available; });
        if (estadoEl) {
          estadoEl.textContent = variante.available ? (estadoEl.getAttribute("data-disponible") || "En stock") : (estadoEl.getAttribute("data-agotado") || "Agotado");
          estadoEl.classList.toggle("agotado", !variante.available);
        }
        if (variante.featured_image && galeriaPrincipal) {
          galeriaPrincipal.src = variante.featured_image;
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener("click", function () {
          var grupo = pill.getAttribute("data-opcion-index");
          root.querySelectorAll('[data-mt-opcion-pill][data-opcion-index="' + grupo + '"]').forEach(function (p) {
            p.classList.remove("is-activa");
            p.setAttribute("aria-pressed", "false");
          });
          pill.classList.add("is-activa");
          pill.setAttribute("aria-pressed", "true");
          actualizar();
        });
      });

      actualizar();
    });
  }

  function initAddToCart() {
    document.querySelectorAll("[data-mt-producto-form]").forEach(function (form) {
      form.addEventListener("submit", function (evt) {
        evt.preventDefault();
        var botones = [form.querySelector("[data-mt-add]"), document.querySelector("[data-mt-add-barra]")].filter(Boolean);
        var estadoEl = form.querySelector("[data-mt-estado]");
        var textos = botones.map(function (b) { return b.textContent; });
        botones.forEach(function (b) { b.disabled = true; b.textContent = "Añadiendo…"; });

        var formData = new FormData(form);
        formData.append("sections", "cart-notification-product,cart-notification-button,cart-icon-bubble");
        formData.append("sections_url", window.location.pathname);

        fetch((window.routes && window.routes.cart_add_url) || "/cart/add", {
          method: "POST",
          headers: { Accept: "application/javascript" },
          body: formData,
        })
          .then(function (response) { return response.json(); })
          .then(function (parsedState) {
            if (parsedState.errors || parsedState.status) {
              if (estadoEl) {
                estadoEl.textContent = (parsedState.errors && parsedState.errors.quantity) || parsedState.description || "No se pudo añadir. Inténtalo de nuevo.";
                estadoEl.classList.add("agotado");
              }
              return;
            }
            var cartNotification = document.querySelector("cart-notification");
            if (cartNotification && typeof cartNotification.renderContents === "function") {
              cartNotification.renderContents(parsedState);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || "/cart";
            }
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            botones.forEach(function (b, i) { b.disabled = false; b.textContent = textos[i]; });
          });
      });
    });
  }

  /* Barra de compra fija en móvil: aparece cuando el botón principal sale de pantalla */
  function initBarraCompra() {
    var barra = document.querySelector("[data-mt-barra]");
    var botonPrincipal = document.querySelector("[data-mt-add]");
    if (!barra || !botonPrincipal || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var fuera = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        barra.classList.toggle("is-visible", fuera);
      });
    });
    observer.observe(botonPrincipal);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initGaleria();
    initVariantes();
    initAddToCart();
    initBarraCompra();
  });
})();
